import * as React from 'react'

function SvgLogoPaintWonder(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 100 13" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#logo_paint_wonder_svg__logo_paint_wonder_svg__clip0)">
        <path
          d="M0 .762h5.23c2.051 0 3.98.94 3.98 3.549 0 2.73-1.559 3.794-3.98 3.794H2.87v3.671H0V.763zm2.87 5.121h1.928c.894 0 1.542-.37 1.542-1.372 0-1.033-.664-1.445-1.542-1.445H2.869v2.817z"
          fill="#C50018"
        />
        <path
          d="M11.172.762h2.916l4.12 11.014H15.21l-.678-1.974H10.69l-.695 1.975H7.05L11.172.761zm.185 6.91h2.5l-1.219-3.856h-.03l-1.25 3.857z"
          fill="#44AEEA"
        />
        <path d="M18.187.762h2.87v11.014h-2.87V.763z" fill="#9E9E9F" />
        <path
          d="M21.318.762h2.948l3.825 6.794h.031V.762h2.699v11.014h-2.946L24.05 4.913h-.03v6.865h-2.7V.761z"
          fill="#56A646"
        />
        <path d="M40.516 3.23h-3.293v8.546h-2.87V3.232h-3.285V.76h9.448v2.47z" fill="#F1CF00" />
        <path
          d="M70.92.762h4.736c3.378 0 5.4 2.052 5.4 5.46 0 3.615-2.052 5.554-5.4 5.554h-4.735V.763zm2.87 8.546h1.357c2.169-.047 3.036-.895 3.036-3.101 0-2.005-1.08-2.976-3.036-2.976H73.79v6.077z"
          fill="#1F5DA8"
        />
        <path d="M81.164.762h8.777v2.3h-5.908V4.99h5.399v2.22h-5.399v2.098h6.155v2.469h-9.024V.761z" fill="#9FC238" />
        <path
          d="M90.188.762h5.616c1.942 0 3.856.88 3.856 3.1 0 1.189-.57 2.313-1.727 2.763v.03c1.172.278 1.51 1.59 1.603 2.638.032.463.078 2.082.464 2.484h-2.839c-.247-.37-.29-1.446-.324-1.76-.078-1.11-.263-2.252-1.604-2.252h-2.169v4.012h-2.876V.761zm2.87 4.782h2.406c.867 0 1.327-.463 1.327-1.301 0-.839-.648-1.189-1.445-1.189h-2.284l-.005 2.49z"
          fill="#9394C6"
        />
        <path
          d="M54.232.762h-2.61l-1.558 8.053h-.03L48.412.762H45.72l-1.626 8.053h-.03L42.504.762h-2.87l2.979 11.014h2.915l1.512-7.59h.03l1.512 7.59h2.87l.529-1.92a6.338 6.338 0 012.25-9.099v.005z"
          fill="#D16C15"
        />
        <path
          d="M67.959.762v6.794h-.03L64.102.762h-2.946v.588a6.333 6.333 0 010 9.974v.453h2.7V4.912h.031l3.825 6.865h2.946V.761h-2.7z"
          fill="#CD609B"
        />
        <path d="M39.835 11.99a1.577 1.577 0 100-3.154 1.577 1.577 0 000 3.155z" fill="#54348B" />
        <path
          d="M63.112 3.929a6.329 6.329 0 00-1.363-2.057 6.334 6.334 0 00-10.835 4.443v.02a6.336 6.336 0 0012.67.017v-.018a6.31 6.31 0 00-.472-2.405z"
          fill="#C50018"
        />
        <path d="M57.25 11.758a5.422 5.422 0 100-10.844 5.422 5.422 0 000 10.844z" fill="#fff" />
        <path
          d="M54.104 4.993h-.732v-.63c.135 0 .27-.009.404-.03a.918.918 0 00.289-.098.564.564 0 00.196-.186c.056-.09.098-.187.126-.29h.729v3.863h-1.012v-2.63zm2.602-1.157h1.101v2.335h.338v.731h-.338v.723h-.957v-.723h-1.374v-.764l1.23-2.302zm.185 1.048h-.01l-.633 1.287h.643V4.884zm1.734-.12c.037-.216.119-.422.24-.605a.833.833 0 01.41-.311c.381-.118.79-.118 1.172 0a.832.832 0 01.409.31c.121.184.203.39.24.606.106.64.106 1.293 0 1.933a1.548 1.548 0 01-.24.6.81.81 0 01-.41.303 2.168 2.168 0 01-1.172 0 .81.81 0 01-.409-.303 1.548 1.548 0 01-.24-.6 5.913 5.913 0 010-1.933zm1.012 2.157a.254.254 0 00.458 0c.06-.178.084-.366.071-.554V5.085a1.427 1.427 0 00-.07-.553.254.254 0 00-.459 0c-.06.178-.084.366-.07.553v1.277a1.43 1.43 0 00.064.559h.006zm-3.132 3.29h-.324V8.937h-.467v-.273h1.258v.274h-.467v1.273zm1.213-.616v.616h-.323V8.664h.322v.664h.605v-.664h.323v1.547h-.323v-.616h-.605z"
          fill="#1F5DA8"
        />
      </g>
      <defs>
        <clipPath id="logo_paint_wonder_svg__logo_paint_wonder_svg__clip0">
          <rect width={100} height={12.671} fill="#fff" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default SvgLogoPaintWonder
